import { createRoot } from 'react-dom/client';
import BlogsPage from '../components/BlogsPage.tsx';
import '../../assets/stylesheets/application.tailwind.css';
import '../i18n/config';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('blogs-page');
  if (container) {
    const root = createRoot(container);
    root.render(<BlogsPage />);
  }
});
